
export const past2020 = {
  introduction: {
    subTitle: '微众银行金融科技高校技术大赛',
    subTitleEn: 'FinTechathon',
    titleImg: 'https://static001.geekbang.org/resource/image/d5/87/d5694e0785cbbd9byy2b29965c0c5887.png',
    mobileTitleImg: 'https://static001.geekbang.org/resource/image/09/2c/09f4c07ab9f645b53fd826d33901cc2c.png',
    intro: [
      'FinTechathon 2020，旨在推动国内及海外高校学生探索金融科技前沿领域的技术突破和应用创新，促进相关专业跨校和校企交流，全面提高学生的创新能力、实践能力和就业竞争力。',
      '历时 80 余天，2020 年大赛采用全新线上挑战模式，吸引了来自全球 212 所知名高校共 700 余名精英学子参赛，区块链与人工智能双赛道共收获 115 份参赛作品，19 支队伍入围总决赛，涌现出众多兼具创意与实践意义的优秀作品。来自北京理工大学的 TAN’s fellow 队伍，成功攻破完全未知的黑盒人脸识别系统，以其超高转移性攻击算法的核心优势和在金融反欺诈模型攻击领域中的出色攻击效果，摘得人工智能赛道的桂冠；华南师范大学的队伍紫荆路航空团设计的“时间银行“区块链公益平台，实现了志愿者累计服务时间到个人数字资产的转换，最终夺得区块链赛道的冠军。'
    ],
    poster: 'https://static001.geekbang.org/resource/image/27/04/27682cd18298597cb88eda1a49b3cb04.jpg',
    video: 'https://media001.geekbang.org/customerTrans/735b007ab30330a3b7781b88c9f22338/32f8f5d3-182cb15f4c6-0000-0000-01d-dbacd.mp4'
  },

  ai: {
    title: '人工智能作品',
    subTitle: 'FINTECHATHON',
    height: '306px',
    content: [
      {
        imgUrl: 'https://static001.geekbang.org/resource/image/45/4d/45c6c26d0344503188890a8628d9804d.jpeg',
        worksname: 'TAN‘s fellow',
        teamName: '第一名',
        desc: 'Fusing Attack 是团队开发的以超高转移性攻击算法为核心优势的针对人脸识别系统的黑盒对抗攻击。依托多种高性能攻击模块和转移性增强模块，Fusing Attack 能够成功攻破完全未知的黑盒人脸识别系统，任意操纵目标模型的识别结果。'
      },
      {
        imgUrl: 'https://static001.geekbang.org/resource/image/e8/01/e887191b92fe591a77954289a1e2b501.jpeg',
        worksname: '一辆二手迈巴赫',
        teamName: '第二名',
        desc: '本次比赛中，团队横向比较了各种攻击方法的有效性，纵向比较了各种模型的优劣程度，在确定方法的基础上尝试不同的叠加模型与权重，最后使用了模型叠加加上 Sample-Wise-Selection 的方式，通过我们的最优攻击方法 SI-DIM 成功攻破了 50% 左右的样本，这在定向黑盒攻击当中是很难以达到的。'
      },
      {
        imgUrl: 'https://static001.geekbang.org/resource/image/5a/98/5af1370e157yy64910e490a2dd899498.jpeg',
        worksname: '铁头娃娃娃娃头铁',
        teamName: '第三名',
        desc: '本作品是针对黑盒的人脸对抗攻击方法。首先，团队利用集成代理模型提升对抗样本的迁移性。然后，利用输入多样性和高斯滤波来破解可能的防御措施。最后，设计了自适应扰动区域以及局部有效梯度的方法来降低扰动大小。'
      }
    ]
  },

  blockchain: {
    title: '区块链作品',
    subTitle: 'FINTECHATHON',
    height: '274px',
    content: [
      {
        imgUrl: 'https://static001.geekbang.org/resource/image/07/f6/07ffe26b882dbbe2c5f0fef4c23b50f6.png',
        worksname: '紫荆路航空团',
        teamName: '第一名',
        desc: '当前志愿服务面临着热情难以维持、“简单的扎堆做，难的没人做”等问题，为此团队提出“时间银行”区块链平台，志愿服务时长通过区块链存证，积累的志愿服务时间的链上存证作为数字资产，不仅可在未来兑换成他人为自己服务，还可支持多元的交易方式，从而构建互助互惠平台。'
      },
      {
        imgUrl: 'https://static001.geekbang.org/resource/image/86/28/86f870f9044df13413c59d99a484da28.png',
        worksname: 'Keep Water',
        teamName: '第二名',
        desc: 'WeHelp 旨在给急需帮助的人与有能力并且愿意给予帮助的人建立联系，充分发挥“爱心陌生人”（指愿意帮助他人并且就在附近的人）的地理优势，并基于一套完整机制防止善行过程中的作弊行为以及奖励救助者。'
      },
      {
        imgUrl: 'https://static001.geekbang.org/resource/image/6b/d2/6bda20080ce99f075c77ce91f7ee49d2.png',
        worksname: '会计无计',
        teamName: '第三名',
        desc: '基于 FISCO BCOS 搭建了财务联盟链，团队设计和开发了基于 UTXO 和同态加密的会计信息系统，利用 UTXO 模型实现了会计的复式记账思想，实现对资金的可追溯性，同态加密解决了上链数据的隐私问题，区块链则保证了会计数据不被篡改。'
      }
    ]
  }
}
